<template>
  <table-setting :ClickMethods="operator_group_add"></table-setting>
</template>
<script>
import TableSetting from './components/TableSetting'
export default {
  components: {
    TableSetting
  },
  methods: {
    async operator_group_add (obj, pagedata) {
      pagedata.forEach(it => {
         if (it.key == 'gameset') {
            obj[it.key] = it.model.slice(0, 6).join('')
            obj['settlement'] = it.model.slice(6, 8).join('')
         } else {
           obj[it.key] = it.model.join('')
         }
      })
      
      try {
        const msg = await this.$axios.operatorGroup.add(obj)
        if (msg.status === 1) {
          this.$Message.success('已新增');
          this.$router.push({ name: 'operator-group' })
        }
      } catch (err) {
        this.$Message.error('请将栏位填写完整');
      }
    }
  }
}
</script>